<template>
  <div>
    <div class="head u-flex">
      <el-descriptions :column="3">
        <el-descriptions-item label="业务类型">
          <el-select v-model="messageType" placeholder="">
            <el-option v-for="items of messageTypeList" :label="items.label" :value="items.value"/>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="信息类型">
          <el-select v-model="type" placeholder="" @change="changeSelect">
            <el-option v-for="item of types" :label="item.label" :value="item.value"/>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="选择时间">
          <el-date-picker v-model="time" type="daterange" align="left" unlink-panels range-separator="-" style="width: 70%" start-placeholder="起始时间" end-placeholder="结束时间"
                          value-format="yyyy-MM-dd HH:mm:ss" clearable :picker-options="pickerOptions"></el-date-picker>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="list" v-if="list.length>0">
      <div class="item u-flex u-row-between" v-for="(item, index) in list" @click="BiddingDetails(item)" :key="index">
        <p class="title">【{{item.adRegions}}】{{ item.title }}</p>
        <p class="time">{{ item.time }}</p>
      </div>
    </div>
    <div class="list" v-else>
      <el-empty description="暂无内容"/>
    </div>
    <page style="padding: 30px 0" @currentPage="currentPage" :total="tablePage.total" ref="pagination"/>
  </div>
</template>

<script>
import page from "@/components/page/pages";
import {locationBiddingPaging} from "@/api/interfaceApi";

export default {
  components: {page},
  data() {
    return {
      type: 0, //类型选择
      messageType: "",
      time: "", //选择时间
      pickerOptions: {
        shortcuts: [{
          text: '今日', onClick(picker) {
            let end = new Date(), start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '昨日', onClick(picker) {
            let end = new Date(), start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周', onClick(picker) {
            let end = new Date(), start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月', onClick(picker) {
            let end = new Date(), start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月', onClick(picker) {
            let end = new Date(), start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      types: [
        {value: 0, label: "全部"},
        {value: 1, label: "招标"},
        {value: 2, label: "中标"},
        {value: 3, label: "采购"},
      ],
      messageTypeList: [{value: "", label: "全部"}],
      list: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  watch: {
    cityNo(e) {
      this.tablePage.currentPage = 1;
      this.getLocationBidding();
    },
    time(e) {
      this.tablePage.currentPage = 1;
      this.getLocationBidding();
    }
  },
  mounted() {
    this.getLocationBidding();
  },
  props: {
    cityNo: {
      type: [String, Number],
      default() {
        return 0
      }
    },
    cityList: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  methods: {
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getLocationBidding();
    },
    getLocationBidding() {
      let start = '';
      let end = '';
      if (this.time) {
        let s=this.time[0].split(' ');
        let e=this.time[1].split(' ');
        start = new Date(s[0]+' 00:00:00') / 1000;
        end = new Date(e[0]+' 23:59:59') / 1000;
      }
      locationBiddingPaging({
        page: this.tablePage.currentPage,
        province: this.cityList.id,
        time: this.time ? start + '-' + end : '0',
        type: this.type,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.list = res.content.data;
          this.tablePage.total = res.total;
          window.scrollTo(0, 60);
        }
      })
    },
    // 下拉框被选中时 页码回到1 重新请求
    changeSelect() {
      this.tablePage.currentPage = 1;
      this.getLocationBidding();
    },
    BiddingDetails(item) {
      console.log(item);
      let routeData = this.$router.resolve({
        name: "policyDetails",
        query: {id: item.bidding_id},
        path: '/article/policyDetails',
      });
      window.open(routeData.href, '_blank')
    },
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
  }
};
</script>

<style lang="scss" scoped>
.head {
  padding-top: 20px;
}

.head-item {
  margin-right: 40px;

  .name {
    font-size: 14px;
    color: #333;
  }
}

.list {
  margin-top: 20px;

  .item {
    padding: 18px 0;
    border-top: 1px dashed #DDDDDD;
    cursor: pointer;
    display: flex;
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-block-end: 0px;
      margin-block-start: 0px;
      overflow: hidden;
      width: 90%;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .time {
      color: #aaa;
      font-size: 14px;
      font-weight: normal;
    }
  }
}
</style>
<style scoped>
.head >>> .el-select .el-input__inner {
  background-color: transparent;
}

.head >>> .el-input--prefix .el-input__inner {
  background-color: transparent;
  padding-left: 15px;
}

.head >>> .el-input__prefix {
  left: auto;
  right: 10px;
}
.head >>> .el-descriptions-item__container {
  display: flex;
  align-items: center;
}
</style>